import { render, staticRenderFns } from "./ReportAging.vue?vue&type=template&id=3fd797b6&"
import script from "./ReportAging.vue?vue&type=script&lang=ts&"
export * from "./ReportAging.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd797b6')) {
      api.createRecord('3fd797b6', component.options)
    } else {
      api.reload('3fd797b6', component.options)
    }
    module.hot.accept("./ReportAging.vue?vue&type=template&id=3fd797b6&", function () {
      api.rerender('3fd797b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-receivables/reports/ReportAging.vue"
export default component.exports